import Image from 'next/image';
import React, { useContext } from 'react';

import Heading from '@components/Heading';
import Section from '@components/Section';
import { ProductPageContext } from '@contexts/PageContext';
import { loaderProp } from '@utils/random';

const MainBenefitsSection = () => {
  const pageData = useContext(ProductPageContext);
  const {
    ledeText,
    firstSectionHeading,
    firstSectionSubheading,
    firstSectionCards,
  } = pageData;

  const [card1, card2, card3] = firstSectionCards;

  const addExtraPadding =
    ledeText === 'Dashboards' ||
    ledeText === 'Search' ||
    ledeText === 'SQL editor';

  return (
    <Section>
      {firstSectionHeading && (
        <div className="mb-6 md:mb-20 max-w-xl text-center">
          <Heading
            Tag="h2"
            size="lg"
            className={`mx-auto 
              ${ledeText.includes('Version') && 'lg:max-w-lg'}
              ${ledeText.includes('Data') && 'lg:max-w-md'}
            `}
          >
            {firstSectionHeading}
          </Heading>

          {firstSectionSubheading && (
            <p className="font-inter font-medium text-xl md:text-2xl mt-4">
              {firstSectionSubheading}
            </p>
          )}
        </div>
      )}

      <div
        className={`text-white rounded-2xl flex flex-col lg:flex-row w-full lg:h-[400px] relative overflow-hidden ${card1.backgroundColor}`}
      >
        <div className="p-10 pb-0 lg:p-16 lg:pr-4">
          <div className="lg:w-[430px]">
            <Heading Tag="h3" size="sm" className="text-white">
              {card1.title}
            </Heading>
            <p className="font-inter font-medium text-lg mt-4 mb-8 lg:mb-0">
              {card1.description}
            </p>
          </div>
        </div>

        <div className="w-full h-full flex justify-end">
          <div
            className={`flex items-end
            ${addExtraPadding ? 'lg:pl-12' : ''}
            ${ledeText === 'Version history' ? 'md:translate-y-8' : ''}
            ${
              ledeText === 'Data catalog' || ledeText === 'Query variables'
                ? 'md:translate-y-12 md:translate-x-10'
                : ''
            }
            ${
              ledeText === 'Shared queries'
                ? 'md:translate-y-8 md:translate-x-2'
                : ''
            }
          `}
          >
            <Image
              alt={card1.image.fields.description}
              src={card1.image.fields.file.url}
              height={card1.image.fields.file.details.image.height}
              width={card1.image.fields.file.details.image.width}
              loader={loaderProp}
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col md:flex-row gap-4 md:gap-8 md:mt-6 w-full lg:min-h-[400px]">
        <div
          className={`rounded-2xl w-full flex ${
            card3 ? 'flex-col' : 'flex-col lg:flex-row'
          } justify-between overflow-hidden ${card2.backgroundColor}`}
        >
          <div className={`p-10 pb-0 lg:p-16 ${card3 ? '' : 'lg:pr-4'}`}>
            <div className={`${card3 || 'lg:w-[430px]'}`}>
              <Heading Tag="h3" size="sm" className="text-white">
                {card2.title}
              </Heading>
              <p className="font-inter font-medium text-lg mt-4 mb-8 lg:mb-0">
                {card2.description}
              </p>
            </div>
          </div>

          <div className="flex justify-end">
            <div className="flex items-end">
              <Image
                alt={card2.image.fields.description}
                src={card2.image.fields.file.url}
                height={card2.image.fields.file.details.image.height}
                width={card2.image.fields.file.details.image.width}
                loader={loaderProp}
              />
            </div>
          </div>
        </div>

        {card3 && (
          <div
            className={`rounded-2xl w-full flex flex-col justify-between overflow-hidden ${card3.backgroundColor}`}
          >
            <div className="p-10 lg:pb-4 lg:p-16 mb-4 md:max-w-auto">
              <Heading Tag="h3" size="sm" className="text-white">
                {card3.title}
              </Heading>
              <p className="font-inter font-medium text-lg mt-4">
                {card3.description}
              </p>
            </div>

            <div className="flex items-end justify-end">
              <Image
                alt={card3.image.fields.description}
                src={card3.image.fields.file.url}
                height={card3.image.fields.file.details.image.height}
                width={card3.image.fields.file.details.image.width}
                loader={loaderProp}
              />
            </div>
          </div>
        )}
      </div>
    </Section>
  );
};

export default MainBenefitsSection;
